export default "__VITE_ASSET__f5644d9c__"